import { Box, Typography } from '@mui/material';
import {
    Memory, People, Search, UploadFile, WhatsApp,
} from '@mui/icons-material';
import CustomBR from '../../foundation/CustomBR';
import {
    ChannelItem,
    ChannelsList,
    DesktopFlowRow,
    DesktopStepCard,
    DottedLine,
    DottedLineHorizontal,
    FeatureIconWrap,
    FlowContainer,
    MiddleStepCard,
    StepBadge,
    StepCard,
} from './EmployerLanding.styles';

const stepOneIconStyle = { margin: '0.5rem auto 0.75rem', width: '3rem', height: '3rem', borderRadius: '0.75rem' };
const channelIconStyle = { width: '2.5rem', height: '2.5rem', margin: '0 auto 0.5rem' };
const stepThreeIconStyle = { width: '3.5rem', height: '3.5rem', margin: '0.5rem auto 0.75rem', background: '#f0f4fc', color: 'inherit' };

const StepOneCardContent = (): JSX.Element => (
    <>
        <StepBadge>1</StepBadge>
        <FeatureIconWrap style={stepOneIconStyle}>
            <UploadFile fontSize="small" />
        </FeatureIconWrap>
        <Typography color="secondary" fontWeight="bold" variant="body1">מפרסמים משרה</Typography>
        <Typography color="secondary" variant="caption">יוצרים משרה בקלות תוך דקות ספורות</Typography>
    </>
);

const StepTwoCardContent = (): JSX.Element => (
    <>
        <StepBadge>2</StepBadge>
        <Typography color="secondary" fontWeight="bold" variant="body2" marginTop="0.25rem">
            המערכת עושה את העבודה
        </Typography>
        <ChannelsList>
            <ChannelItem>
                <FeatureIconWrap style={channelIconStyle}>
                    <WhatsApp fontSize="small" />
                </FeatureIconWrap>
                <Typography color="primary" fontWeight="bold" variant="caption" display="block">בוט וואטסאפ חכם</Typography>
                <Typography color="secondary" variant="caption">מגיע גם למועמדים שלא חיפשו באופן אקטיבי</Typography>
            </ChannelItem>
            <ChannelItem>
                <FeatureIconWrap style={channelIconStyle}>
                    <Search fontSize="small" />
                </FeatureIconWrap>
                <Typography color="primary" fontWeight="bold" variant="caption" display="block">מחפשי עבודה אקטיבים</Typography>
                <Typography color="secondary" variant="caption">מועמדים נחשפים למשרה שלכם</Typography>
            </ChannelItem>
            <ChannelItem>
                <FeatureIconWrap style={channelIconStyle}>
                    <Memory fontSize="small" />
                </FeatureIconWrap>
                <Typography color="primary" fontWeight="bold" variant="caption" display="block">התאמה של AI</Typography>
                <Typography color="secondary" variant="caption">סינון והתאמה לגיוסי מסה</Typography>
            </ChannelItem>
        </ChannelsList>
    </>
);

const StepThreeCardContent = (): JSX.Element => (
    <>
        <StepBadge>3</StepBadge>
        <FeatureIconWrap style={stepThreeIconStyle}>
            <People />
        </FeatureIconWrap>
        <Typography color="secondary" fontWeight="bold" variant="body1">מקבלים מועמדים איכותיים</Typography>
        <Typography color="secondary" variant="caption">מועמדים רלוונטיים מגיעים אליכם תוך זמן קצר</Typography>
    </>
);

const MobileHowItWorksFlow = (): JSX.Element => (
    <FlowContainer>
        <StepCard>
            <StepOneCardContent />
        </StepCard>

        <DottedLine />

        <MiddleStepCard>
            <StepTwoCardContent />
        </MiddleStepCard>

        <DottedLine />

        <StepCard>
            <StepThreeCardContent />
        </StepCard>
    </FlowContainer>
);

const DesktopHowItWorksFlow = (): JSX.Element => (
    <DesktopFlowRow>
        <DesktopStepCard>
            <StepOneCardContent />
        </DesktopStepCard>

        <DottedLineHorizontal />

        <MiddleStepCard>
            <StepTwoCardContent />
        </MiddleStepCard>

        <DottedLineHorizontal />

        <DesktopStepCard>
            <StepThreeCardContent />
        </DesktopStepCard>
    </DesktopFlowRow>
);

const ElpHowItWorks = (): JSX.Element => (
    <Box id="how-it-works">
        <Typography color="secondary" fontWeight="bold" variant="h4" textAlign="center">
            איך זה עובד?
        </Typography>
        <Typography color="secondary" variant="body1" textAlign="center">
            3 צעדים פשוטים למציאת עובדים איכותיים
        </Typography>
        <CustomBR times={2} />

        <MobileHowItWorksFlow />
        <DesktopHowItWorksFlow />
    </Box>
);

export default ElpHowItWorks;
